import { StatusLight, Text } from '@react-spectrum/s2';
import { style } from '@react-spectrum/s2/style' with { type: 'macro' };

import type { ProcessStatus } from '../../../../bridge/types/process.ts';

import { PROCESS_STATUS_CONFIG } from './processConstants';

export const ProcessStatusLight = ({
	status,
}: {
	status: ProcessStatus | undefined;
}) => {
	const effectiveStatus: ProcessStatus =
		status && (status as string) in PROCESS_STATUS_CONFIG ? status : 'proposed';
	const config = PROCESS_STATUS_CONFIG[effectiveStatus];
	return (
		<StatusLight variant={config.variant}>
			<Text
				styles={style({
					font: 'ui',
				})}
			>
				{config.label}
			</Text>
		</StatusLight>
	);
};
